import { EducationStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Learning to Innovation:
               <br />
               Our Education Software Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of experience in education software development, we create seamless, scalable, and high-performance solutions. Our systematic approach optimizes learning experiences, simplifies administration, and boosts student engagement.
            </p>

            <EducationStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
